import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade PJ). */
export type RequerimentoRenovacaoRegularidadePjJob = ReportJob;
export type RequerimentoRenovacaoRegularidadePjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) do Requerimento de Renovação de Regularidade PJ. */
@Injectable({ providedIn: 'root' })
export class RequerimentoRenovacaoRegularidadePjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'requerimento-renovacao-regularidade-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.requerimentoRenovacaoRegularidadePj;
}
